import _ from 'lodash';
import {
  createWebhook,
  toggleWebhookActivity,
  updateWebhook,
} from '../../../../redux/actions/application';
import { getSelectedApplicationId } from '../../../../selectors/applications/applications';
import { applicationsService } from '../../../../transport/services/applications';
import { ApplicationWebhookFormData } from './application-webhooks.types';

export const APPLICATION_WEBHOOKS_ACTION_NAMES = {
  SHOW_INFO_SIDEBAR: 'APPLICATION_WEBHOOKS_ACTION_NAMES-SHOW_INFO_SIDEBAR',
  HIDE_INFO_SIDEBAR: 'APPLICATION_WEBHOOKS_ACTION_NAMES-HIDE_INFO_SIDEBAR',

  SEND_WEBHOOK_START: 'APPLICATION_WEBHOOKS_ACTION_NAMES-SEND_WEBHOOK_START',
  SEND_WEBHOOK_SUCCESS:
    'APPLICATION_WEBHOOKS_ACTION_NAMES-SEND_WEBHOOK_SUCCESS',
  SEND_WEBHOOK_ERROR: 'APPLICATION_WEBHOOKS_ACTION_NAMES-SEND_WEBHOOK_ERROR',
};

export const showInfoSidebar = (webhookUrl?: string) => ({
  type: APPLICATION_WEBHOOKS_ACTION_NAMES.SHOW_INFO_SIDEBAR,
  payload: webhookUrl,
});

export const hideInfoSidebar = () => ({
  type: APPLICATION_WEBHOOKS_ACTION_NAMES.HIDE_INFO_SIDEBAR,
  payload: undefined,
});

const convertWebhookFormDataToWebhook = (data: ApplicationWebhookFormData) => ({
  url: data.url,
  active: data.active,
  filters: _.map(data.events, (event: string) => ({
    type: event,
    bodyFilters: _.map(data.bodyFilters, (item) => [item]),
  })),
});

export const saveWebhook =
  (
    data: ApplicationWebhookFormData,
    initialValues: Partial<ApplicationWebhookFormData>,
  ) =>
  (dispatch, getState) => {
    const webhook = convertWebhookFormDataToWebhook(data);

    if (!initialValues.url) {
      return createWebhook(webhook)(dispatch, getState);
    }

    if (initialValues.active !== data.active) {
      return toggleWebhookActivity({ ...webhook, active: !data.active })(
        dispatch,
        getState,
      );
    }

    return updateWebhook(webhook)(dispatch, getState);
  };

export const sendWebhookTest = (webhookUrl: string) => (dispatch, getState) => {
  const state = getState();
  const applicationId = getSelectedApplicationId(state);

  return dispatch({
    types: [
      APPLICATION_WEBHOOKS_ACTION_NAMES.SEND_WEBHOOK_START,
      APPLICATION_WEBHOOKS_ACTION_NAMES.SEND_WEBHOOK_SUCCESS,
      APPLICATION_WEBHOOKS_ACTION_NAMES.SEND_WEBHOOK_ERROR,
    ],
    callApi: () =>
      applicationsService.sendWebhookTest({ applicationId, webhookUrl }),
  });
};
